import { combineReducers } from 'redux'
import newContent from './newContent'
import isVisible from './isVisible'


export default combineReducers({
  newContent,
  isVisible
})
